import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { UsersService, UserResponse as User } from '@itemis-solutions/platform-client-sdk'

export const useUserStore = defineStore('user', () => {
  const userState = ref<User>({
    id: '',
    default_organization_id: '',
    unique_name: '',
    email: '',
    email_public: false,
    name: '',
    name_public: false,
    picture: '',
    subject_id: '',
  })

  const getUserInfo = computed(() => userState.value)

  async function initUserData(payload: User) {
    userState.value = payload
  }

  function $reset() {
    userState.value = {
      id: '',
      default_organization_id: '',
      unique_name: '',
      email: '',
      email_public: false,
      name: '',
      name_public: false,
      picture: '',
      subject_id: '',
    }
  }

  function resetUserData() {
    $reset()
  }

  async function updateUserInfo() {
    const { data } = await UsersService.getCurrentUser({})
    initUserData(data)
  }

  return {
    state: userState,
    getUserInfo,
    initUserData,
    $reset,
    resetUserData,
    updateUserInfo,
  }
})
